import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import {
  CTA_UNLOCK_YOUR_OFFER,
  DISCLAIMER_CONSULTATION_CANCEL,
} from 'consts/copy';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_ROSACEA_CONTENT: SimpleHeroProps = {
  header: (
    <React.Fragment>
      Rosacea relief,
      <br />
      revolutionized
    </React.Fragment>
  ),
  body: 'Stop fearing those flare ups. Our Custom Formula can now be made with a powerful mix of rosacea-fighting ingredients, to help soothe your inflamed skin and reduce redness, while still fighting acne.',
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_OFFER,
    disclaimerText: (
      <React.Fragment>{DISCLAIMER_CONSULTATION_CANCEL}</React.Fragment>
    ),
  },
  media: (
    <React.Fragment>
      <StaticImage
        src="../images/headerRosaceaDesktop@2x.jpg"
        alt="woman holding Curology bottle"
        width={641}
        css={desktopOnly()}
      />
      <StaticImage
        src="../images/headerRosaceaMobile@2x.jpg"
        alt="woman holding Curology bottle"
        loading="eager"
        layout="fullWidth"
        css={mobileOnly()}
      />
    </React.Fragment>
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
};
